import { isMobile } from "./isMobile";

function initializeBackToTopButton() {
  var $btn = $(".page-top");

  if (!$btn.length) return;

  var btnFixedPosition = isMobile() ? 20 : 0;
  var yTop = 0;
  var pxInBackToTop = 180 + yTop;
  var msInBTTBtn = 300;
  var msBTTScroll = 800;
  var btnDefaultY = "-100px";

  $btn.css("bottom", btnDefaultY);

  var isInBttBtn = false;

  $(window)
    .off("scroll.backToTop resize.backToTop")
    .on("scroll.backToTop resize.backToTop", setBttPos);

  function setBttPos() {
    var y = $(window).scrollTop();

    if (y > pxInBackToTop) {
      if (!isInBttBtn) {
        isInBttBtn = true;

        $btn
          .stop()
          .animate(
            { bottom: btnFixedPosition + "px" },
            msInBTTBtn,
            "easeOutBack"
          );
      }
    } else {
      if (isInBttBtn) {
        isInBttBtn = false;

        $btn.stop().animate({ bottom: btnDefaultY }, msInBTTBtn, "easeInBack");
      }
    }
  }

  $btn.off("click.backToTop").on("click.backToTop", function (e) {
    $("html, body")
      .stop()
      .animate({ scrollTop: yTop }, msBTTScroll, "easeOutQuint");

    e.preventDefault();
  });
}

$(function () {
  initializeBackToTopButton();
});

$(document).ajaxComplete(function () {
  initializeBackToTopButton();
});
